import React from "react";

import l from "components/util/l";

const Value = ({ value, className }) =>
  <td className={value ? className : `${className} change-view-diff-empty`}>
    {value || "—"}
  </td>

const FieldsView = ({ fields, isShowingHead = true }) =>
  fields.length == 0 ? null :
    <table className="table change-view-diff">
      {
        isShowingHead &&
        <thead>
          <tr>
            <th className="change-view-diff-key">{l("Campo%VG352")}</th>
            <th>{l("Antes%DF008")}</th>
            <th>{l("Después%DF009")}</th>
          </tr>
        </thead>
      }
      <tbody>
        {fields.map((field) => (
          <tr key={field.key}>
            <td className="change-view-diff-key">{field.label}</td>
            <Value value={field.current} className="change-view-diff-old" />
            <Value value={field.imported} className="change-view-diff-new" />
          </tr>
        ))}
      </tbody>
    </table>

export default FieldsView;
